import React, { useEffect, useRef, useState } from "react";
import BaseModal from "../../../../../components/ui/BaseModal";
import BaseDataTableV2 from "../../../../../components/ui/BaseDataTableV2";
import { useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import useAuth from "../../../../../hooks/useAuth";
import { Menu, MenuItem } from "@mui/material";
import { fetchJobsCompleted } from "../../../../../services/api/user";
import { debounce } from "lodash";
import JobsCompletedCard from "./JobsCompletedCard";

const JobsCompletedModal = ({ open, close }) => {
  const { id: userId } = useParams();
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50, search: "" });
  const [queryParams, setQueryParams] = useState({ page: 1, limit: 50, search: "" });
  const [searchQuery, setSearchQuery] = useState("");

  const { data: completedJobsData, isLoading: isCompletedJobsLoading } = useQuery({
    queryKey: [
      "completedJobsData",
      userId,
      queryParams.page,
      queryParams.limit,
      queryParams.search,
    ],
    queryFn: () =>
      fetchJobsCompleted(userId, queryParams.page, queryParams.limit, queryParams.search),
    keepPreviousData: true,
  });

  const navigate = useNavigate();
  const [contextMenu, setContextMenu] = useState(null);
  const [selectedWorkOrder, setSelectedWorkOrder] = useState(null);

  const { auth, authRole } = useAuth();
  const companyId = auth?.user?.company?.id;

  const [rowCount, setRowCount] = useState(0);

  useEffect(() => {
    if (completedJobsData?.jobsCompleted) {
      setRowCount(completedJobsData.totalCount);
    }
  }, [completedJobsData]);
  const handleNavigate = (id) => {
    navigate(`/workOrder/details/${id}`);
  };
  const handleContextMenu = (event, item) => {
    event.preventDefault();
    setContextMenu(
      contextMenu === null
        ? {
            mouseX: event.clientX + 2,
            mouseY: event.clientY - 6,
          }
        : null,
    );
    setSelectedWorkOrder(item);
  };
  const handleClose = () => {
    setContextMenu(null);
    setSelectedWorkOrder(null);
  };
  const columns = [
    {
      field: "id",
      headerName: "",
      flex: 1,
      renderCell: (params) => {
        return (
          <div
            onClick={() => navigate(`/workOrder/details/${params.row.workOrder.id}`)}
            className="m-[14px] w-full cursor-pointer"
          >
            <JobsCompletedCard jobsCompleted={params.row} />
          </div>
        );
      },
    },
  ];
  const handlePaginationChange = (newPaginationModel) => {
    setPaginationModel(newPaginationModel);
    setQueryParams((prev) => ({
      ...prev,
      page: newPaginationModel.page + 1,
      limit: newPaginationModel.pageSize,
    }));
  };

  const updateQueryParamsDebounced = useRef(
    debounce((query) => {
      setQueryParams((prev) => ({
        ...prev,
        search: query.trim() || "",
        page: 1,
      }));
    }, 500),
  ).current;
  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    updateQueryParamsDebounced(query);
  };
  return (
    <BaseModal
      className="-top-[70px]"
      open={open}
      close={() => close(false)}
      style={{ width: "1200px" }}
    >
      <div className="flex flex-col max-h-[90vh]">
        {" "}
        <div className="sticky top-0 z-20 bg-white pt-4 px-4  flex items-center justify-between">
          <h5 className="text-dark font-medium">Jobs Completed</h5>
          <div className="w-2/6"></div>
        </div>
        <div className="flex-1 overflow-y-auto mt-4 min-w-[900px]">
          <BaseDataTableV2
            slots={{ columnHeaders: () => null }}
            hideHeader
            columnHeaderHeight={0}
            autoHeight
            getRowHeight={() => "auto"}
            rowHeight={null}
            columns={columns}
            data={completedJobsData?.jobsCompleted || []}
            isLoading={isCompletedJobsLoading}
            hideFooter={false}
            pagination
            rowCount={rowCount}
            paginationMode="server"
            paginationModel={paginationModel}
            onPaginationModelChange={handlePaginationChange}
            pageSizeOptions={[10, 20, 50, 100]}
          />
        </div>
      </div>

      <Menu
        open={contextMenu !== null}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorPosition={
          contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined
        }
      >
        <MenuItem
          onClick={() => {
            handleNavigate(selectedWorkOrder.id);
            handleClose();
          }}
        >
          <p>Open</p>
        </MenuItem>
        <MenuItem
          onClick={() => {
            window.open(`/workOrder/details/${selectedWorkOrder.id}`, "_blank");
            handleClose();
          }}
        >
          <p>Open in New Tab</p>
        </MenuItem>
      </Menu>
    </BaseModal>
  );
};

export default JobsCompletedModal;
